import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { ModalSize, SuiModalService } from "@richardlt/ng2-semantic-ui";
import { Router } from "@angular/router";
import {
	ChatModal,
	ViewDetailsModal,
} from "src/modules/features/contractor/modals";
import { AppFilter, ConfirmModal } from "src/modules/shared";
import { EwalletService } from "src/modules/features/admin/services/ewallet";
@Component({
	selector: "app-withdrawal-request-row",
	templateUrl: "./withdrawal-request-row.component.html",
	styleUrls: ["./withdrawal-request-row.component.scss"],
})
export class WithdrawalRequestRowComponent implements OnInit {
	@Input() request: any;
	@Input() currencyCode: string;
	@Output() onCancel: EventEmitter<any> = new EventEmitter();

	pending: boolean;
	success: any;
	error: any;
	filter: AppFilter = new AppFilter();
	request2;

	constructor(
		private modalService: SuiModalService,
		private router: Router,
		private walletSvc: EwalletService
	) {}

	viewDetails() {
		this.modalService.open(
			new ViewDetailsModal("View Withdrawal Request Details", this.request)
		);
	}

	cancelRequest(request) {
		this.onCancel.emit(request);
		// this.walletSvc.cancel();
		// this.router.navigate(['/contractor/wallet/withdrawal-request']);
	}

	chatWithNCC() {
		this.modalService
			.open(new ChatModal(ModalSize.Tiny, this.request.withdrawalRequestId))
			.onDeny(() => {
        this.getWithdrawalRequestDetails(this.request?.withdrawalRequestId);
			});
	}

	ngOnInit(): void {
		this.getWithdrawalRequestDetails(this.request?.withdrawalRequestId);
	}

	getWithdrawalRequestDetails(withdrawalRequestId: string) {
		// this.pending = true;
		this.walletSvc
			.getWithdrawalRequestDetailsById({
				withdrawalRequestId: withdrawalRequestId,
				params: this.filter,
			})
			.subscribe({
				next: (res: any) => {
					this.request2 = res;
					// this.pending = false;
				},
				error: (error: any) => {
					console.log(error);
					// this.pending = false;
				},
			});
	}
}
